<p-table [value]="paginationResult.entities" [lazy]="true" (onLazyLoad)="loadData($event)"
  [rows]="paginationRequest.pageSize" [totalRecords]="paginationResult.filteredEntities"
  [rowsPerPageOptions]="[10, 20, 30, 40, 50]" [paginator]="true" [(selection)]="selectedEntities" [loading]="loading"
  [rowHover]="true" [showCurrentPageReport]="true" dataKey="id"
  currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}" class="custom-table"
  styleClass="p-datatable-striped" appendTo="body">
  <!-- #region TABLE TITLE DEFINITION -->
  <ng-template pTemplate="caption">
    @if (showTitle) {
      <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
        {{ 'tableManagement.cardLists.cardListsManagement' | translate }}
      </div>
    }
  </ng-template>
  <!-- #endregion TABLE TITE DEFINITION -->

  <!-- #region TABLE COLUMN DEFINITION -->
  <ng-template pTemplate="header">
    <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
      <!-- SELECT -->
      <th class="checkbox-column">
        <div class="d-flex justify-content-center">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </div>
      </th>

      <!-- LOGO -->
      <th pSortableColumn="logo">
        <div class="d-flex align-items-center h-100">
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.brands.logo' | translate }}
          </div>
        </div>
      </th>

      <!-- NUMBER -->
      <th pSortableColumn="number">
        <div class="d-flex align-items-center h-100">
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.cardLists.number' | translate }}
          </div>

          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="number"></p-sortIcon>
            <p-columnFilter field="number" type="text" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- TYPE -->
      <th pSortableColumn="type.name">
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'control-panel.vehicles.vehicleType' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="type.name"></p-sortIcon>
            <p-columnFilter field="type" type="text" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- CODE PRODUCT LIMIT  -->
      <th pSortableColumn="type.codeProductLimit">
        <div title="{{ 'tableManagement.cardLists.codeProductLimitShort' | translate }}"
          class="d-flex align-items-center h-100">
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.cardLists.codeProductLimitShort' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="type.codeProductLimit"></p-sortIcon>
            <p-columnFilter field="codeProductLimit" type="text" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- OPERATION LIMIT  -->
      <th pSortableColumn="type.operationLimit">
        <div title="{{ 'tableManagement.cardLists.operationLimit' | translate }}"
          class="d-flex align-items-center h-100">
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.cardLists.operationLimitShort' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="type.operationLimit"></p-sortIcon>
            <p-columnFilter field="operationLimit" type="text" matchMode="contains"
              placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
            [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </div>
        </div>
      </th>


      <!-- VEHICLE -->
      @if (!nested) {
        <th pSortableColumn="vehicle.name">
          <div class="d-flex align-items-center h-100">
            <!-- COLUMN TITLE -->
            <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
              {{ 'tableManagement.cardLists.vehicle' | translate }}
            </div>
            <!-- COLUMN SORT && FILTER ICONS -->
            <div class="d-flex align-items-center h-100">
              <p-sortIcon field="vehicle.name"></p-sortIcon>
              <p-columnFilter field="vehicle" type="text" matchMode="contains"
                placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
              [showOperator]="false" [showAddButton]="false"></p-columnFilter>
            </div>
          </div>
        </th>
      }

      <!-- PRODUCT LIMIT  -->
      @if (!nested) {
        <th pSortableColumn="type.productLimit">
          <div title="{{ 'tableManagement.cardLists.productLimit' | translate }}"
            class="d-flex align-items-center h-100">
            <!-- COLUMN TITLE -->
            <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
              {{ 'tableManagement.cardLists.productLimitShort' | translate }}
            </div>
            <!-- COLUMN SORT && FILTER ICONS -->
            <div class="d-flex align-items-center h-100">
              <p-sortIcon field="type.productLimit"></p-sortIcon>
              <p-columnFilter field="productLimit" type="text" matchMode="contains"
                placeholder="{{ 'general.search' | translate }}" display="menu" [showMatchModes]="false"
              [showOperator]="false" [showAddButton]="false"></p-columnFilter>
            </div>
          </div>
        </th>
      }



      <!-- EXPIRATION DATE -->
      <th pSortableColumn="expirationDate">
        <div title="{{ 'tableManagement.cardLists.expirationDate' | translate }}"
          class="d-flex align-items-center h-100">
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.cardLists.expirationDateShort' | translate }}
          </div>
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="expirationDate"></p-sortIcon>
          </div>
        </div>
      </th>

      <!-- ASSIGN DATE -->
      @if (nested) {
        <th pSortableColumn="assignDate">
          <div title="{{ 'tableManagement.cardLists.deassignDate' | translate }}"
            class="d-flex align-items-center h-100">
            <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
              {{ 'tableManagement.cardLists.assignDateShort' | translate }}
            </div>
            <div class="d-flex align-items-center h-100">
              <p-sortIcon field="assignDate"></p-sortIcon>
            </div>
          </div>
        </th>
      }

      <!-- DEASSIGN DATE -->
      <th pSortableColumn="deassignDate">
        <div title="{{ 'tableManagement.cardLists.deassignDate' | translate }}"
          class="d-flex align-items-center h-100">
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'tableManagement.cardLists.deassignDateShort' | translate }}
          </div>
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="deassignDate"></p-sortIcon>
          </div>
        </div>
      </th>

      <!-- ACTIVE -->
      <th pSortableColumn="disabled">
        <div class="d-flex align-items-center h-100">
          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'general.active' | translate }}
          </div>

          <!-- COLUMN SORT && FILTER ICONS -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="disabled"></p-sortIcon>
            <p-columnFilter field="disabled" type="boolean" display="menu"
            [showApplyButton]="false"></p-columnFilter>
          </div>
        </div>
      </th>

      <!-- DELETE -->
      <th class="button-column"></th>
    </tr>
  </ng-template>
  <!-- #endregion TABLE COLUMN DEFINITION -->

  <!-- #region TABLE BODY -->
  <ng-template pTemplate="body" let-card>
    <tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="editDialog(card)">
      <!-- SELECT -->
      <td>
        <div class="d-flex justify-content-center">
          <p-tableCheckbox [value]="card"></p-tableCheckbox>
        </div>
      </td>

      <!-- IMAGE -->
      <td>
        @if (!card.type.image) {
          <div>
            <!-- <img #image src="{{'../../../../../../../../assets/images/UI_Elements/HD_transparent_picture.png'}}"
            class="custom-user-profile-image mx-auto d-block p-0" -->
            <img #image src="{{ '/assets/images/UI_Elements/no-image-available.svg' }}" class="img-responsive"
              [style]="{ 'max-height': '50px' }" />
          </div>
        } @else {
          <div>
            <img #image src="{{ card.type.image.imageEncoded }}" class="img-responsive"
              [style]="{ 'max-height': '50px' }" />
          </div>
        }
        <!-- <div>
        <img *ngIf='logoImageUrl' id='uploadImageIcon' class='ps-3' alt='' src='{{ logoImageUrl }}' class='img-responsive' [style]="{'max-height': '100px;', 'width':'50px', 'margin-right':'10px'}"/>
        <img *ngIf='selectedBrand?.logo?.imageEncoded' id='uploadedImage' class='ps-3' alt='' [src]='logoEncodedImage' class='img-responsive' [style]="{'max-height': '100px;', 'width':'50px', 'margin-right':'10px'}">
      </div> -->
    </td>

    <!-- NUMBER -->
    <td>
      {{ card.number }}
    </td>


    <!-- TYPE -->
    <td>
      {{ card.type?.name }}
    </td>

    <td>
      {{card.type?.codeProductLimit}}
    </td>

    <!-- OPERATION LIMIT -->
    <td>
      {{ card.type?.operationLimit }}
    </td>

    <!-- VEHICLE -->
    @if (!nested) {
      <td>
        {{ card.vehicle?.name }}
      </td>
    }
    <!-- PRODUCT LIMIT -->
    @if (!nested) {
      <td>
        {{ card.type?.productLimit }}
      </td>
    }


    <!-- EXPIRATION DATE -->
    <td>
      {{ card.expirationDate | date : 'dd/MM/yyyy' }}
    </td>

    <!-- ASSIGN DATE -->
    @if (nested) {
      <td>
        {{ card.assignDate | date : 'dd/MM/yyyy' }}
      </td>
    }

    <!-- DEASSIGN DATE -->
    <td>
      {{ card.deassignDate | date : 'dd/MM/yyyy' }}
    </td>

    <!-- ACTIVE -->
    <td>
      <div class="d-flex justify-content-center align-items-center">
					<i class="pi" [ngClass]="{
							'true-icon pi-check-circle': !card.disabled,
							'false-icon pi-times-circle': card.disabled
						}"></i>
      </div>
    </td>

    <!-- DELETE -->
    <td class="button-column">
      @if ((!card.consumption || card.consumption?.length === 0) && isDisabledGranted) {
        <div>
          <button  type="button" class="btn custom-table-remove-button" (click)="onDeleteCard(card)">
            <svg-icon
              src="assets/icons/trash.svg"
              class="d-flex flex-wrap custom-table-remove-button-icon"
              [svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
            ></svg-icon>
          </button>
        </div>
      }

    </td>
  </tr>
</ng-template>
<!-- #endregion TABLE BODY -->

<!-- #region TABLE EMPTY MESSAGE -->
<ng-template pTemplate="emptymessage">
  <tr>
    <td colspan="12" class="p-0">
      <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
					{{ 'table.tableEmptyMessage' | translate }}!
				</div>
    </td>
  </tr>
</ng-template>
<!-- #endregion TABLE EMPTY MESSAGE -->

<!-- #region TABLE FOOTER -->
<ng-template pTemplate="footer">
  @if (nested) {
    <tr>
      <td colspan="12" class="p-0">
        <div class="d-flex flex-row align-items-center p-3 gap-3">
          <div class="d-flex">
            <!-- <form-input [required]='false' [isDisabled]="isEditingDisabled" fieldName="{{ 'tableManagement.cardLists.availableCards' | translate }}" [style]="{'margin-right':'50px'}"> -->
            <!-- <p-select
            [options]='availableCardsList' [(ngModel)]='selectedAvailableCard'
            [placeholder]="availableCardListPlaceHolder"
            dataKey='id' optionLabel='number'
            [style]="{'width':'250px', 'margin-right':'10px'}"
            [disabled]='!availableCardsList || isEditingDisabled'
            appendTo='body'
            filter="true" filterBy="number">
          </p-select>
          <button *ngIf="selectedAvailableCard" class="btn custom-expand-button" type="button" i18n-alt alt="{{'general.addAvailableCard' | translate}}" (click)="onAddAvailableCard()" [disabled]='isEditingDisabled' [style]="{'margin-right':'5px'}">
            <svg-icon
              class="d-flex m-0 p-0 custom-expand-button-icon"
              src="assets/icons/arrow-up.svg"
              [svgStyle]="{'height.px': 30, 'width.px': 30}"
            ></svg-icon>
          </button>
          <button class="btn custom-expand-button" type="button" i18n-alt alt="{{'general.addAvailableCard' | translate}}" (click)="create()" [disabled]='isEditingDisabled' [style]="{'margin-right':'10px'}">
            <svg-icon
              class="d-flex m-0 p-0 custom-expand-button-icon"
              src="assets/icons/add.svg"
              [svgStyle]="{'height.px': 30, 'width.px': 30}"
            ></svg-icon>
          </button> -->
          @if (isCreateGranted) {
            <app-table-add-button [text]="'tableManagement.cardLists.card' | translate"
            (btnClick)="create()"></app-table-add-button>
          }
          <!-- CHANGE STATUS BUTTON -->
          <app-table-change-status-button (btnClick)="changeStatus()"
          [isDisabled]="selectedEntities.length === 0 || !isDisabledGranted"></app-table-change-status-button>
        <!-- </form-input> -->
      </div>
      <div class="d-flex flex-row" style="margin-left: auto">
        <!--  EXCEL BUTTON -->
        <app-table-excel-button [isDisabled]="isEditingDisabled" class="buttonTableExcel"
        (btnClick)="exportExcel()"></app-table-excel-button>
      </div>
    </div>
  </td>
</tr>
}

@if (!nested) {
  <tr>
    <td colspan="12" class="p-0">
      <div class="d-flex flex-row align-items-center p-3 gap-3">
        <div class="d-flex">
          <!-- ADD CARD BUTTON -->
          <app-table-add-button [text]="'tableManagement.cardLists.cards' | translate"
          (btnClick)="create()"></app-table-add-button>
          <!-- CHANGE STATUS BUTTON -->
          <app-table-change-status-button (btnClick)="changeStatus()"
          [isDisabled]="selectedEntities.length === 0"></app-table-change-status-button>
        </div>
        <div class="d-flex flex-row" style="margin-left: auto">
          <!-- UPLOAD FILE FORM  -->
          <div class="buttonTableExcel custom-image-button"
            pTooltip="{{ 'tableManagement.cardLists.cardsRenewalProcess' | translate }}"
            tooltipPosition="top" (click)="showFileForm()">
            <svg-icon src="assets/icons/upload-file.svg"
            [svgStyle]="{ 'height.px': 30, 'width.px': 30 }"></svg-icon>
          </div>
          <!--  EXCEL BUTTON -->
          <app-table-excel-button class="buttonTableExcel"
          (btnClick)="exportExcel()"></app-table-excel-button>
        </div>
      </div>
    </td>
  </tr>
}
</ng-template>
<!-- #endregion TABLE FOOTER -->
</p-table>

<!-- CHANGE STATUS DIALOG -->
@if (showStatusDialog) {
  <div>
    <app-change-status-shared [items]="'tableManagement.cardLists.cards' | translate" [display]="true"
      [service]="cardService" [entitiesList]="selectedEntities" (return)="refreshList($event)"
    (close)="closeStatusDialog($event)"></app-change-status-shared>
  </div>
}

<!-- CARD FORM -->
<app-card-form [vehicle]="vehicle" (return)="afterSave()"></app-card-form>

<!-- UPLOAD FILE FORM -->
<app-upload-file-form (refreshTable)="refresh()" [renewalType]="renewalType"
[title]="fileFormTitle"></app-upload-file-form>

<p-confirmDialog
  #saveEventDialog
  [header]="'confirm.critic' | translate"
  [message]="'control-panel.delete-dialog.message' | translate"
  class="custom-dialog"
  icon="pi pi-exclamation-triangle"
  key="card-list"
  >
  <ng-template pTemplate="footer">
    <!-- REJECT BUTTON -->
    <button (click)="saveEventDialog.onReject()" class="custom-button">
      {{ 'general.no' | translate }}
    </button>
    <!-- ACCEPT BUTTON -->
    <button (click)="saveEventDialog.onAccept()" class="custom-button">
      {{ 'general.yes' | translate }}
    </button>
  </ng-template>
</p-confirmDialog>